import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';
import { City } from '../entities/city';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';

interface ApiResponse {
  status: string;
  data: City[];
}

@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor(private http: HttpClient, private cookies: CookieService) {  }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private citiesServiceUrl = this.apiServicesUrl + '/city';

  getCities(): Observable<ApiResponse> {
    if (this.cookies.check('cities')) {
      return of({status: 'success', data: JSON.parse(this.cookies.get('cities'))});
    }
    return this.http.get<ApiResponse>(this.citiesServiceUrl)
    .pipe(
      catchError(this.handleError<ApiResponse>('getCities'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
